const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/invoices.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/invoices')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ────────────────────────────────────────────────────────────────────

type InvoiceStatus = 'draft' | 'sent' | 'paid' | 'overdue' | 'cancelled';
interface LineItem {
  description: string;
  quantity: number;
  unitPrice: number;
}
interface Invoice {
  id: string;
  invoiceNumber: string;
  customerName: string;
  customerEmail: string;
  date: string;
  dueDate: string;
  lineItems: LineItem[];
  subtotal: number;
  taxRate: number;
  taxAmount: number;
  tax: number;
  discountAmount: number;
  total: number;
  status: InvoiceStatus;
  notes?: string;
  stripeInvoiceId?: string;
  stripePaymentIntent?: string;
  paymentMethod?: string;
}

// 10%

// ─── Component ────────────────────────────────────────────────────────────────